var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowFilledRight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99984 1.66699C5.39984 1.66699 1.6665 5.40033 1.6665 10.0003C1.6665 14.6003 5.39984 18.3337 9.99984 18.3337C14.5998 18.3337 18.3332 14.6003 18.3332 10.0003C18.3332 5.40033 14.5998 1.66699 9.99984 1.66699ZM13.3582 10.442L10.8582 12.942C10.7332 13.067 10.5748 13.1253 10.4165 13.1253C10.2582 13.1253 10.0998 13.067 9.97484 12.942C9.73317 12.7003 9.73317 12.3003 9.97484 12.0587L11.4082 10.6253H7.08317C6.7415 10.6253 6.45817 10.342 6.45817 10.0003C6.45817 9.65866 6.7415 9.37533 7.08317 9.37533H11.4082L9.97484 7.94199C9.73317 7.70033 9.73317 7.30033 9.97484 7.05866C10.2165 6.81699 10.6165 6.81699 10.8582 7.05866L13.3582 9.55866C13.5998 9.80033 13.5998 10.2003 13.3582 10.442Z",
    fill: "#686C81"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowFilledRight);
export default __webpack_public_path__ + "static/media/arrow-filled-right.46ce7198e59cbff33239a0a613d15579.svg";
export { ForwardRef as ReactComponent };